import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { incidentalLoanService } from '../../services/incidentalLoanService'

function IncidentalLoans() {
  const [loans, setLoans] = useState([])
  const [loading, setLoading] = useState(true)
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)

  useEffect(() => {
    fetchLoans()
  }, [page, search, statusFilter])

  const fetchLoans = async () => {
    try {
      setLoading(true)
      const response = await incidentalLoanService.getAll({
        page,
        limit: 20,
        search,
        status: statusFilter || undefined
      })
      setLoans(response.data.data || [])
      const meta = response.data.meta
      setTotalPages(meta?.totalPages || 1)
    } catch (error) {
      console.error('Error fetching incidental loans:', error)
    } finally {
      setLoading(false)
    }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(value || 0)
  }

  const formatDate = (dateStr) => {
    if (!dateStr) return '-'
    return new Date(dateStr).toLocaleDateString('id-ID')
  }

  const getStatusBadge = (status) => {
    const badges = {
      'Pengajuan': 'badge-warning',
      'Disetujui': 'badge-info',
      'Dicairkan': 'badge-primary',
      'Lunas': 'badge-success',
      'Ditolak': 'badge-danger'
    }
    return badges[status] || 'badge-secondary'
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Data Pinjaman Insidentil</h3>
        <div className="card-tools">
          <Link to="/incidental-loans/new" className="btn btn-primary btn-sm">
            <i className="fas fa-plus mr-1"></i> Pengajuan Baru
          </Link>
        </div>
      </div>
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-4">
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Cari nama atau no. pinjaman..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && setPage(1)}
              />
              <div className="input-group-append">
                <button className="btn btn-default" onClick={() => setPage(1)}>
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <select
              className="form-control"
              value={statusFilter}
              onChange={(e) => {
                setStatusFilter(e.target.value)
                setPage(1)
              }}
            >
              <option value="">Semua Status</option>
              <option value="Pengajuan">Pengajuan</option>
              <option value="Disetujui">Disetujui</option>
              <option value="Dicairkan">Dicairkan</option>
              <option value="Lunas">Lunas</option>
              <option value="Ditolak">Ditolak</option>
            </select>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th>No. Pinjaman</th>
                <th>Nama Anggota</th>
                <th>Jumlah Pinjaman</th>
                <th>Sisa Pokok</th>
                <th>Sisa Tenor</th>
                <th>Tgl Pengajuan</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Memuat data...
                  </td>
                </tr>
              ) : !Array.isArray(loans) || loans.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">Tidak ada data</td>
                </tr>
              ) : (
                loans.map((loan) => (
                  <tr key={loan.NoPinjaman}>
                    <td>{loan.NoPinjaman}</td>
                    <td>{loan.Nama}</td>
                    <td className="text-right">{formatCurrency(loan.JumlahPinjaman)}</td>
                    <td className="text-right">{formatCurrency(loan.SisaPokok)}</td>
                    <td className="text-center">{loan.SisaTenor} bulan</td>
                    <td>{formatDate(loan.TglPengajuan)}</td>
                    <td>
                      <span className={`badge ${getStatusBadge(loan.Status)}`}>
                        {loan.Status}
                      </span>
                    </td>
                    <td>
                      <Link to={`/incidental-loans/${loan.NoPinjaman}`} className="btn btn-info btn-sm">
                        <i className="fas fa-eye"></i>
                      </Link>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <div>Halaman {page} dari {totalPages}</div>
          <div>
            <button
              className="btn btn-default btn-sm mr-1"
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default IncidentalLoans
